import { AutoCompleteDictionary } from "components/AutoCompleteDictionary/AutoCompleteDictionary";
import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
interface UnitDictionaryPropsType {
    label?: string,
    name: string,
    hasBorder?: boolean,
    required?: boolean,
    value?:string,
    mode?:string
    resetForm?:any,
    Change?: (e) => void,
    setUnitDictionary?: (e) => void,
    returnObj?:any,
    disabledItems?:any
    valueString?:any
}

export const UnitDictionary = ({ label="Unit", returnObj,hasBorder,value,mode,valueString ,name,required , resetForm ,Change , disabledItems ,setUnitDictionary}: UnitDictionaryPropsType) => {

        return (
     <>
    <AutoCompleteDictionary 
    disabledItems={disabledItems}
    baseUrl={INVENTORYANDSALES_URL} valueString={valueString} url={ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.Unit.dictionaryId} name={name} label={label} mode={mode} required={required} onChange={(e)=>{setUnitDictionary&&setUnitDictionary({Value :e.Name , Id : e.Id})}} value={value} returnObj={returnObj} Change={Change} resetForm={resetForm}/>
     </>
    )
}